import { CommonModule } from '@angular/common';
import { Component, inject, input, output, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AUTHENTICATED_USER_SERVICE } from '@app/shared/auth/authenticated-user-service/authenticated-user-service.token';
import {
  CommentDialog,
  CommentDialogData,
} from '@app/shared/dialogs/comment-dialog/comment-dialog';
import { ValidationCircuits } from '@app/features/contracts/validation/validation-circuit';
import { ValidationSubjectItem } from '@app/features/contracts/validation/validation-subject.model';
import { RxjsDirective } from '@app/shared/rxjs.directive';
import { filter, switchMap, tap } from 'rxjs';

@Component({
  selector: 'app-button-cancel-validation-request',
  imports: [CommonModule, MatButtonModule, MatIconModule, MatTooltipModule],
  templateUrl: './button-cancel-validation-request.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './button-cancel-validation-request.scss',
})
export class ButtonCancelValidationRequest extends RxjsDirective {
  /** Le sujet validé : un contrat d'embauche, ou un avenant. */
  contract = input.required<ValidationSubjectItem>();
  private readonly validationCircuits = inject(ValidationCircuits);
  protected circuit = () => this.validationCircuits.of(this.contract());
  requestValidationCancelled = output<void>();

  dialog = inject(MatDialog);
  authenticatedUserService = inject(AUTHENTICATED_USER_SERVICE);

  get canCancelRequestValidation(): boolean {
    const allowedStatuses = [
      'REX_VALIDATING',
      'REX_VALIDATED',
      'DA_VALIDATING',
      'DA_VALIDATED',
      'DP_VALIDATING',
      'DP_VALIDATED',
      'RRH_VALIDATING',
      'RRH_VALIDATED',
      'DRH_VALIDATING',
    ];
    return allowedStatuses.includes(this.contract().status);
  }

  cancelRequestValidation() {
    const dialogRef = this.dialog.open<CommentDialog, CommentDialogData, string | undefined>(
      CommentDialog,
      {
        data: {
          title: "Commentaire d'annulation",
          required: true,
        },
        minWidth: '700px',
      },
    );

    this.register(
      dialogRef
        .afterClosed()
        .pipe(
          filter((comment: string | undefined): comment is string => comment !== undefined),
          switchMap((comment: string) => this.circuit().cancel(this.contract().id, comment)),
          tap(() => this.requestValidationCancelled.emit()),
        )
        .subscribe(),
    );
  }
}
